/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_TitleInputs */

const en_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description Export`)
};

const fr_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de la description audio`)
};

const de_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung exportieren`)
};

const it_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione della descrizione audio`)
};

const ru_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт аудиоописания`)
};

const es_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de descripción de audio`)
};

const zh_cn2_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述导出`)
};

const ja_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明のエクスポート`)
};

const hi_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण निर्यात करें`)
};

const pt_pt2_audio_description_export_title = /** @type {(inputs: Audio_Description_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description Export" |
*
* @param {Audio_Description_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_title = /** @type {((inputs?: Audio_Description_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_title(inputs)
	if (locale === "de") return de_audio_description_export_title(inputs)
	if (locale === "it") return it_audio_description_export_title(inputs)
	if (locale === "ru") return ru_audio_description_export_title(inputs)
	if (locale === "es") return es_audio_description_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_title(inputs)
	if (locale === "ja") return ja_audio_description_export_title(inputs)
	if (locale === "hi") return hi_audio_description_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_title(inputs)
	return en_audio_description_export_title(inputs)
});